import React, { Component } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Fisrt from '../../Assets/1.png'
import Second from '../../Assets/2.png'

function HomeCarousel() {
    return (
        <Carousel autoPlay infiniteLoop interval={3000} showThumbs={false}>

            <div>
                <img src={Fisrt} />
            </div>
            <div>
                <img src={Second} />
            </div>

        </Carousel>
    );
}

export default HomeCarousel;